// // Get all buttons with Sage or Warm Taupe labels
// const newButtons = document.querySelectorAll('[data-swatch-button="true"][data-label="Cacao"], [data-swatch-button="true"][data-label="Teal"], [data-swatch-button="true"][data-label="Terracotta"]');



// newButtons.forEach(button => {
//   // Create NEW tag
//   const newTag = document.createElement('span');
//   newTag.style.position = 'absolute';
//   newTag.style.fontFamily = 'Arial !important';
//   newTag.style.top = '-18px';
//   newTag.style.right = '-8px';
//   newTag.style.backgroundColor = '#CC5525';
//   newTag.style.color = 'white';
//   newTag.style.fontSize = '10px';
//   newTag.style.padding = '1px 4px';
//   newTag.style.borderRadius = '6px';
//   newTag.textContent = 'NEW';
  
//   // Set button to relative positioning
//   button.style.position = 'relative';
  
//   // Add NEW tag to button
//   button.appendChild(newTag);
// });


/**
 * Variant Inventory Update
 *
 * Updates the inventory counter when a variant is selected
 * This function mirrors the approach used by the theme to update prices
 */

(function() {
  // Update inventory counter when variant is changed
  function updateInventoryCounter() {
    // Listen for variant change events
    document.addEventListener('product:variant-change', function(event) {
      const variant = event.detail.variant;
      if (!variant) return;
      
      // Find the inventory counter element
      const inventoryCounter = document.querySelector('.inventory-counter_new');
      if (!inventoryCounter) return;
      
      // Get variant inventory data
      const inventoryJson = document.querySelector('[data-product-inventory-json]');
      if (!inventoryJson) return;
      
      try {
        const inventoryData = JSON.parse(inventoryJson.innerHTML).inventory;
        if (!inventoryData || !inventoryData[variant.id]) return;
        
        // Get inventory quantity for this variant
        const variantInventory = inventoryData[variant.id].inventory_quantity;
        
        // Update the inventory counter text
        const countElement = inventoryCounter.querySelector('b');
        if (countElement) {
          countElement.textContent = variantInventory;
        }
        
        // Show/hide inventory counter based on inventory management
        if (inventoryData[variant.id].inventory_management === null) {
          inventoryCounter.style.display = 'none';
        } else {
          inventoryCounter.style.display = '';
        }
      } catch (e) {
        console.error('Error updating inventory counter:', e);
      }
    });
  }

//Search Bar Function
  document.addEventListener('DOMContentLoaded', function() {
    const desktopSearch = document.querySelector('.desktop-search');
    const mobileSearch = document.querySelector('.mobile-search');
    const breakpoint = 768;

    function updateSearchDisplay() {
        const isMobile = window.innerWidth <= breakpoint;
        
        if (isMobile) {
            desktopSearch.style.display = 'none';
            mobileSearch.style.display = 'flex';
        } else {
            desktopSearch.style.display = 'flex';
            mobileSearch.style.display = 'none';
        }
    }

    // Initial check
    updateSearchDisplay();

    // Debounce function to limit how often the resize handler fires
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    // Add event listeners with debounce
    window.addEventListener('resize', debounce(updateSearchDisplay, 250));
    window.addEventListener('orientationchange', debounce(updateSearchDisplay, 250));

    // Force update on load to ensure correct initial state
    window.addEventListener('load', updateSearchDisplay);
});

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateInventoryCounter);
  } else {
    updateInventoryCounter();
  }
})(); 







// Lightbox effect script (using existing .image__reveal-container, with rect caching)
window.addEventListener('DOMContentLoaded', function() {
  // Check if device is mobile
  function isMobileDevice() {
    return window.innerWidth <= 768 || ('ontouchstart' in window);
  }

  // Initialize lightbox effect
  function initLightbox(mainImg) {
    if (!mainImg) {
      return;
    }

    // Disable lightbox on mobile devices
    if (isMobileDevice()) {
      return;
    }

    // Ensure parent container has relative positioning
    const revealContainer = mainImg.parentNode;
    if (getComputedStyle(revealContainer).position === 'static') {
      revealContainer.style.position = 'relative';
    }

    // Create or update lens
    let lens = document.getElementById('lens');
    if (!lens) {
      lens = document.createElement('div');
      lens.id = 'lens';
      revealContainer.appendChild(lens);
    }

    // Create or update zoom-result
    let zoomResult = document.getElementById('zoom-result');
    if (!zoomResult) {
      zoomResult = document.createElement('div');
      zoomResult.id = 'zoom-result';
      document.body.appendChild(zoomResult);
    }

    // Create or update zoom-img
    let zoomImg = document.getElementById('zoom-img');
    if (!zoomImg) {
      zoomImg = document.createElement('img');
      zoomImg.id = 'zoom-img';
      zoomResult.appendChild(zoomImg);
    }
    
    const bigSrc = mainImg.currentSrc || mainImg.src;
    try {
      const zoomUrl = new URL(bigSrc, window.location.origin);
      zoomUrl.searchParams.set('width', '900');
      zoomImg.src = zoomUrl.toString();
    } catch (error) {
      zoomImg.src = bigSrc.replace('300x300', '900x900');
    }

    // Create or update mask
    let mask = document.getElementById('lightbox-mask');
    if (!mask) {
      mask = document.createElement('div');
      mask.id = 'lightbox-mask';
      document.body.appendChild(mask);
    }

    const zoom = 2; // Zoom factor
    let cachedRect = null;

    function getCursorPos(e) {
      const rect = cachedRect || mainImg.getBoundingClientRect();
      let x = e.clientX - rect.left;
      let y = e.clientY - rect.top;
      x = x / (rect.right - rect.left) * mainImg.width;
      y = y / (rect.bottom - rect.top) * mainImg.height;
      return { x, y };
    }

    // Remove old event listeners
    const oldMainImg = document.querySelector('.product__media-item:not(.hidden) .image__img');
    if (oldMainImg && oldMainImg !== mainImg) {
      oldMainImg.removeEventListener('mouseenter', handleMouseEnter);
      oldMainImg.removeEventListener('mousemove', handleMouseMove);
      oldMainImg.removeEventListener('mouseleave', handleMouseLeave);
    }

    // Event handlers
    function handleMouseEnter(e) {
      lens.style.display = 'block';
      zoomResult.style.display = 'block';
      mask.style.display = 'block';
      cachedRect = mainImg.getBoundingClientRect();
      zoomResult.style.top = cachedRect.top + 'px';
      zoomResult.style.left = (cachedRect.right + 20) + 'px';
      zoomResult.style.height = cachedRect.height + 'px';
      zoomResult.style.width = cachedRect.height + 'px';
      // Add fade-in effect
      zoomResult.style.opacity = '0';
      setTimeout(() => {
        zoomResult.style.opacity = '1';
      }, 10);
    }

    function handleMouseMove(e) {
      lens.style.display = 'block';
      zoomResult.style.display = 'block';
      mask.style.display = 'block';
      const rect = cachedRect;
      const pos = getCursorPos(e);
      let x = pos.x;
      let y = pos.y;
      const lensW = lens.offsetWidth;
      const lensH = lens.offsetHeight;
      x = Math.max(lensW/2, Math.min(x, mainImg.width - lensW/2));
      y = Math.max(lensH/2, Math.min(y, mainImg.height - lensH/2));
      lens.style.left = (x - lensW/2) + 'px';
      lens.style.top = (y - lensH/2) + 'px';
      zoomImg.style.width = mainImg.width * zoom + 'px';
      zoomImg.style.height = mainImg.height * zoom + 'px';
      zoomImg.style.left = -(x * zoom - zoomResult.offsetWidth/2) + 'px';
      zoomImg.style.top = -(y * zoom - zoomResult.offsetHeight/2) + 'px';
    }

    function handleMouseLeave() {
      // Add fade-out effect
      zoomResult.style.opacity = '0';
      setTimeout(() => {
        lens.style.display = 'none';
        zoomResult.style.display = 'none';
        mask.style.display = 'none';
        cachedRect = null;
      }, 200); // Wait for fade-out animation
    }

    // Add new event listeners
    mainImg.addEventListener('mouseenter', handleMouseEnter);
    mainImg.addEventListener('mousemove', handleMouseMove);
    mainImg.addEventListener('mouseleave', handleMouseLeave);
  }

  // Handle window resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      const isMobile = isMobileDevice();
      const lens = document.getElementById('lens');
      const zoomResult = document.getElementById('zoom-result');
      const mask = document.getElementById('lightbox-mask');
      
      if (isMobile) {
        // Hide all lightbox elements on mobile
        if (lens) lens.style.display = 'none';
        if (zoomResult) zoomResult.style.display = 'none';
        if (mask) mask.style.display = 'none';
      } else {
        // Reinitialize current visible image on desktop
        const visibleImg = document.querySelector('.product__media-item:not(.hidden) .image__img');
        if (visibleImg) {
          initLightbox(visibleImg);
        }
      }
    }, 250); // Debounce
  });

  // Initialize first visible image
  const productMediaItems = document.querySelectorAll('.product__media-item');
  let mainImg = null;
  for (let item of productMediaItems) {
    if (!item.classList.contains('hidden')) {
      mainImg = item.querySelector('.image__img');
      break;
    }
  }
  initLightbox(mainImg);

  // Observe image switching
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.classList.contains('product__media-item')) {
          const isHidden = target.classList.contains('hidden');
          if (!isHidden) {
            const newMainImg = target.querySelector('.image__img');
            if (newMainImg) {
              initLightbox(newMainImg);
            }
          }
        }
      }
    });
  });

  // Observe all product__media-item changes
  productMediaItems.forEach(function(item) {
    observer.observe(item, {
      attributes: true,
      attributeFilter: ['class']
    });
  });
});


// Wait for both drawer-menu and target element, then run callback
function waitForElement(selector, cb) {
  const interval = setInterval(() => {
    const el = document.querySelector(selector);
    if (el) {
      clearInterval(interval);
      cb(el);
    }
  }, 200);
}

// Sync z-index for ShopifyChat button and FLYOUT/POPUP dialogs based on drawer-menu state
waitForElement('.drawer-menu.popover', (drawerMenu) => {
  // ShopifyChat button logic. Shopify now renders a <shopify-chat> host;
  // keep the legacy ID as a fallback for older app versions.
  waitForElement('shopify-chat, #ShopifyChat', (chatBtn) => {
    const updateChatZIndex = () => {
      const isActive = drawerMenu.classList.contains('active');
      const isVisible = drawerMenu.classList.contains('visible');
      if (isActive && isVisible) {
        chatBtn.style.setProperty('z-index', '499', 'important');
      } else {
        const zIndex = window.matchMedia('(max-width: 749px)').matches ? '8999' : '9000';
        chatBtn.style.setProperty('z-index', zIndex, 'important');
      }
    };
    updateChatZIndex();
    const observer = new MutationObserver(updateChatZIndex);
    observer.observe(drawerMenu, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', updateChatZIndex);
  });

  // FLYOUT dialog logic
  waitForElement('div[role="dialog"][aria-modal="true"][aria-label="FLYOUT Form"]', (flyout) => {
    const updateFlyoutZIndex = () => {
      const isActive = drawerMenu.classList.contains('active');
      if (isActive) {
        flyout.style.zIndex = '499';
      } else {
        flyout.style.zIndex = '9000';
      }
    };
    updateFlyoutZIndex();
    const observer = new MutationObserver(updateFlyoutZIndex);
    observer.observe(drawerMenu, { attributes: true, attributeFilter: ['class'] });
  });

  // POPUP dialog logic
  waitForElement('div[role="dialog"][aria-modal="true"][aria-label="POPUP Form"]', (popup) => {
    const updatePopupZIndex = () => {
      const isActive = drawerMenu.classList.contains('active');
      if (isActive) {
        popup.style.zIndex = '499';
      } else {
        popup.style.zIndex = '9000';
      }
    };
    updatePopupZIndex();
    const observer = new MutationObserver(updatePopupZIndex);
    observer.observe(drawerMenu, { attributes: true, attributeFilter: ['class'] });
  });
});

/**
 * Product NEW Badge
 *
 * Shows a "NEW" badge on product images for specific colors
 */

// Colors that should show the NEW badge
const newBadgeColors = ['teal', 'cacao', 'terracotta'];

// Colors that should show the SALE badge (hyphenated for normalizeColorName compatibility)
const saleBadgeColors = ['gold', 'ice-blue', 'light-grey'];

// Debug mode - set to false in production
const newBadgeDebug = false;

function logNewBadge(...args) {
  if (newBadgeDebug) {
    console.log('[NEW Badge]', ...args);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  logNewBadge('DOM loaded, initializing...');
  updateNewBadgeOnPageLoad();
});

// Listen for variant changes
document.addEventListener('product:variant-change', function(event) {
  const variant = event.detail?.variant;
  if (!variant) {
    logNewBadge('No variant in event');
    return;
  }

  logNewBadge('Variant changed:', variant);
  logNewBadge('  option1:', variant.option1);
  logNewBadge('  options:', variant.options);
  
  // Smart detection: find which option is the color option
  let colorOption = null;
  
  // Method 1: Check variant.options (with option names if available)
  if (variant.options && variant.options.length > 0) {
    // Try to find by checking which option value matches our newBadgeColors
    for (let i = 0; i < variant.options.length; i++) {
      const optionValue = variant.options[i];
      if (optionValue) {
        const normalized = normalizeColorName(optionValue);
        if (newBadgeColors.some(c => normalized.includes(c))) {
          colorOption = optionValue;
          logNewBadge('  Found color option by value matching at index', i, ':', colorOption);
          break;
        }
      }
    }
  }
  
  // Method 2: Try to get option names from DOM to identify which is Color
  if (!colorOption) {
    const optionLabels = document.querySelectorAll('.product__label');
    if (optionLabels.length > 0) {
      for (let i = 0; i < optionLabels.length; i++) {
        const label = optionLabels[i].textContent?.toLowerCase() || '';
        if (label.includes('color') || label.includes('颜色')) {
          // This is the color option, get its value
          const optionSelectors = document.querySelectorAll('[data-option-buttons]');
          if (optionSelectors[i]) {
            const selectedBtn = optionSelectors[i].querySelector('.selected');
            if (selectedBtn) {
              colorOption = selectedBtn.dataset.optionValue || selectedBtn.dataset.label || selectedBtn.textContent;
              logNewBadge('  Found color option by label at index', i, ':', colorOption);
            }
          }
          break;
        }
      }
    }
  }
  
  // Method 3: Fallback - check if option1 contains any of our newBadgeColors
  if (!colorOption && variant.option1) {
    const normalizedOption1 = normalizeColorName(variant.option1);
    if (newBadgeColors.some(c => normalizedOption1.includes(c))) {
      colorOption = variant.option1;
      logNewBadge('  Using option1 as color option:', colorOption);
    }
  }
  
  // Method 4: Last resort - use option1 if it's the only option, or just try all options
  if (!colorOption) {
    logNewBadge('  Falling back to checking all options...');
    const allOptions = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    for (const opt of allOptions) {
      const normalized = normalizeColorName(opt);
      if (newBadgeColors.some(c => normalized.includes(c))) {
        colorOption = opt;
        logNewBadge('  Found color in options:', colorOption);
        break;
      }
    }
    // If still nothing, use first option just in case
    if (!colorOption && allOptions.length > 0) {
      colorOption = allOptions[0];
      logNewBadge('  Using first option as fallback:', colorOption);
    }
  }

  logNewBadge('  Final colorOption:', colorOption);
  updateNewBadge(colorOption);
  updateSaleBadge(colorOption);
});

function updateNewBadgeOnPageLoad() {
  logNewBadge('Checking for selected color on page load...');

  // Method 1: Find color option by label first
  const optionLabels = document.querySelectorAll('.product__label');
  if (optionLabels.length > 0) {
    for (let i = 0; i < optionLabels.length; i++) {
      const label = optionLabels[i].textContent?.toLowerCase() || '';
      if (label.includes('color') || label.includes('颜色')) {
        logNewBadge('Found color option label at index', i, ':', optionLabels[i].textContent);
        
        // Check for selected swatch button in this option group
        const optionSelectors = document.querySelectorAll('[data-option-buttons]');
        if (optionSelectors[i]) {
          const selectedBtn = optionSelectors[i].querySelector('.selected');
          if (selectedBtn) {
            const colorName = selectedBtn.dataset.optionValue || selectedBtn.dataset.label || selectedBtn.textContent;
            logNewBadge('Found selected color button value:', colorName);
            updateNewBadge(colorName);
            updateSaleBadge(colorName);
            return;
          }
        }
        
        // Check for select dropdown in this option group
        const selects = document.querySelectorAll('.product-form select[name^="options["]');
        if (selects[i] && selects[i].value) {
          logNewBadge('Found selected color select value:', selects[i].value);
          updateNewBadge(selects[i].value);
          updateSaleBadge(selects[i].value);
          return;
        }
        break;
      }
    }
  }

  // Method 2: Check radio input with "Color" in name
  const selectedVariant = document.querySelector('.product-form input[name*="Color"]:checked');
  if (selectedVariant) {
    logNewBadge('Found radio input with Color, value:', selectedVariant.value);
    updateNewBadge(selectedVariant.value);
    updateSaleBadge(selectedVariant.value);
    return;
  }

  // Method 3: Look for any selected swatch button and check if value matches newBadgeColors
  const colorButtons = document.querySelectorAll('[data-option-buttons] .selected');
  for (const btn of colorButtons) {
    const colorName = btn.dataset.optionValue || btn.dataset.label || btn.textContent;
    if (colorName) {
      const normalized = normalizeColorName(colorName);
      if (newBadgeColors.some(c => normalized.includes(c))) {
        logNewBadge('Found color button with matching value:', colorName);
        updateNewBadge(colorName);
        updateSaleBadge(colorName);
        return;
      }
    }
  }

  // Method 4: Check any select and see if value matches
  const formSelects = document.querySelectorAll('.product-form select[name^="options["]');
  if (formSelects.length > 0) {
    for (const select of formSelects) {
      if (select.value) {
        const normalized = normalizeColorName(select.value);
        if (newBadgeColors.some(c => normalized.includes(c))) {
          logNewBadge('Found select with matching value:', select.name, select.value);
          updateNewBadge(select.value);
          updateSaleBadge(select.value);
          return;
        }
      }
    }
  }

  // Method 5: Fallback - try any selected element
  const anySelected = document.querySelectorAll('.product-form .selected');
  if (anySelected.length > 0) {
    logNewBadge('Found .selected elements:', anySelected.length);
    for (const el of anySelected) {
      const value = el.dataset.optionValue || el.dataset.label || el.textContent;
      if (value) {
        const normalized = normalizeColorName(value);
        if (newBadgeColors.some(c => normalized.includes(c))) {
          logNewBadge('Found .selected with matching value:', value);
          updateNewBadge(value);
          updateSaleBadge(value);
          return;
        }
      }
    }
  }

  logNewBadge('No selected color found');
}

// Normalize color name for comparison - convert spaces to hyphens and lowercase
function normalizeColorName(colorName) {
  if (!colorName) return '';
  return colorName.toLowerCase().trim().replace(/\s+/g, '-');
}

function updateNewBadge(colorName) {
  const badge = document.getElementById('product-new-badge');
  if (!badge) {
    logNewBadge('Badge element not found!');
    return;
  }

  if (!colorName) {
    logNewBadge('No color name provided');
    badge.classList.remove('visible');
    return;
  }

  // Normalize color name - convert "Red Earth" to "red-earth"
  const normalizedColor = normalizeColorName(colorName);
  logNewBadge('Original color:', colorName);
  logNewBadge('Normalized color:', normalizedColor);
  logNewBadge('Against new colors:', newBadgeColors);

  // Check if this color should show NEW badge
  const shouldShowBadge = newBadgeColors.some(function(newColor) {
    const match = normalizedColor.includes(newColor.toLowerCase());
    logNewBadge('  Checking:', newColor, 'against', normalizedColor, '->', match);
    return match;
  });

  logNewBadge('Should show badge:', shouldShowBadge);

  if (shouldShowBadge) {
    badge.classList.add('visible');
  } else {
    badge.classList.remove('visible');
  }
}

function updateSaleBadge(colorName) {
  const badge = document.getElementById('product-sale-badge');
  if (!badge) {
    console.log('[SALE Badge] Badge element not found!');
    return;
  }

  if (!colorName) {
    badge.classList.remove('visible');
    return;
  }

  const normalizedColor = normalizeColorName(colorName);
  console.log('[SALE Badge] Color:', colorName, '-> Normalized:', normalizedColor);

  const shouldShowSale = saleBadgeColors.some(function(saleColor) {
    return normalizedColor.includes(saleColor.toLowerCase());
  });

  console.log('[SALE Badge] Should show sale:', shouldShowSale);

  if (shouldShowSale) {
    badge.classList.add('visible');
  } else {
    badge.classList.remove('visible');
  }
}
